var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"utils"},[_c('div',{staticClass:"list"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.toUrl('/utils/smsInquiry')}}},[_vm._v("短信查询")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }